import * as variables from './variables.js';

import { Analytics } from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import './component/menu.service';

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import Forms from './component/Forms';
Forms.init();

// @ts-ignore
var Accordion = require('./component/Accordion/Accordion.js');
var availableJobsAccordion = new Accordion({
	scope: '.__careers',
	doChangeText: true
});
availableJobsAccordion.activate();

import entryVideo from './component/entryVideo';
entryVideo('.__entry .masthead');